import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { fieldStyles } from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import { ErrorComp } from 'core/components/errorComp/errorComp';
import Grid from 'core/grid/domain/grid';
import { LovItem } from 'core/metamodel/mdEntity';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { DialogAncestor, DialogProps } from 'core/common/page/dialogAncestor';
import { ZzUploadFlatButton } from '../../components/buttons/buttons';
import { uploadAxios } from '../../common/config/axios-config';
import { DMLOPERATION, EntityStatus } from '../../event/eventDomain';
import commonService from '../../common/service/commonService';
import Toggle from 'material-ui/Toggle';
import { MdCheckbox } from '../../components/fields/fields';


/* ************************************************************************************************
 * ***********   DIALOG  *************************************************************
 * ********************************************************************************************** */


@observer
export class GridImportDialog extends DialogAncestor<DialogProps, undefined, String> {

  private grid: Grid;
  @observable private importConfig: LovItem;
  @observable private resultMessage: String;
  @observable private showOverride: boolean = false;
  @observable private ignoreUpdate: boolean = false;
  @observable private ignoreEmptyValueOnUpdate: boolean = false;


  @action open(resolve: any, reject: any, grid: Grid) {

    console.log('GridImportDialog: Opening dialog');

    this.resolve = resolve;
    this.reject = reject;
    this.dialogOpen = true;
    this.grid = grid;
  }



  @action close = () => {
    this.dialogOpen = false;
    this.resolve("OK");
  };


  @action onChange = (value: LovItem) => {
    console.log(value)
    this.importConfig = value
  };

  @action showOverrideHandler = (evt, bulik) => {
    this.showOverride = bulik;
  };

  render() {

    console.log('MultiUpdateDialog: rendering dialog');

    if (!this.grid) return null;


    const actions = [
      <FlatButton
        label="Close"
        secondary
        onClick={this.close}
      />,
    ];

    return (
      <Dialog
        title={`Select file to import ${this.grid.$gridLocationRef.$entityRef.label}s`}
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        contentStyle={{width: '60%', maxWidth: 'none'}}
        bodyStyle={{overflow:'visible'}}
      >

        <ErrorComp messages={this.$errors}/>



        <div className="row">
          <div className="col-xs-12" >
            <span>Select Import config</span>
            <StyledSelect name="selectImportConfig" value={this.importConfig} options={this.grid.$gridLocationRef.importConfigs} onChange={this.onChange}
                          {...fieldStyles.small.styledSelect} fullWidth clearable={false}/>
          </div>
        </div>

        <div className="row">
          <Toggle label="Override import settings" toggled={this.showOverride}
                  onToggle={this.showOverrideHandler} style={{width: "unset", marginTop: 20}}
                  labelStyle={{marginRight: 10, whiteSpace: 'nowrap'}}/>
        </div>

        {this.showOverride && (
          <div className="row">
            <MdCheckbox name="ignoreUpdate" checked={this.ignoreUpdate}
                        label={`Do not update existing ${this.grid.$gridLocationRef.$entityRef.label}s`}
                        onCheck={e => this.ignoreUpdate = e.target.checked} />
          </div>
        )}

        {this.showOverride && (
          <div className="row">
            <MdCheckbox name="ignoreEmptyValueOnUpdate" checked={this.ignoreEmptyValueOnUpdate}
                        label={`Do not set empty values when updating existing ${this.grid.$gridLocationRef.$entityRef.label}s`}
                        onCheck={e => this.ignoreEmptyValueOnUpdate = e.target.checked} />
          </div>
        )}


        {this.importConfig && (
          <div className="row" style={{marginTop: 20}}>
            <div className="col-xs-12" >
              <ZzUploadFlatButton label="Import File" handleFileUpload={this.handleFileUpload}/>
            </div>
          </div>
        )}

        {this.resultMessage && (
          <div className="row">
            <div className="col-xs-12" >
              <h5 style={{color: "red"}}>{this.resultMessage}</h5>
            </div>
          </div>
        )}

      </Dialog>
    );
  }

  @action handleFileUpload = (files: FileList) => {

    let data = new FormData();


    for (let i = 0; i < files.length; i++) {
      let file = files.item(i);
      data.append('file[' + i + ']', file, file.name);
    }

    commonService.loading(true);

    let params: any = {importConfigId: this.importConfig.value};
    if (this.showOverride) {
      params.ignoreUpdate = this.ignoreUpdate;
      params.ignoreEmptyValueOnUpdate = this.ignoreEmptyValueOnUpdate;
    }

    return uploadAxios.post('/core/dataimport/grid', data, {params: params, showPrettyError: true})
      .then((response) => {
        console.log(response)
        let statuses: EntityStatus[] = response.data
        let inserted = statuses.filter(s => s.operation === DMLOPERATION.INSERT).length
        let updated = statuses.filter(s => s.operation === DMLOPERATION.UPDATE).length
        this.resultMessage = `Inserted ${inserted} new ${this.grid.$entityRef.label}s, Updated ${updated} existing ${this.grid.$entityRef.label}s`
        commonService.loading(false);
      }, error => {
        this.$errors = error.getMessages();
      });





  };

}





// WEBPACK FOOTER //
// ./src/core/grid/component/gridImportDialog.tsx